module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row item-view"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFetching),
      expression: "!isFetching"
    }],
    staticClass: "col-12"
  }, [(_vm.pendingBids) ? _c('b-table', {
    class: {
      'is-loading': _vm.isFetching
    },
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.pendingBids.data,
      "fields": _vm.pendingBidsFields,
      "per-page": parseInt(_vm.pendingBids.per_page),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "busy": _vm.isFetching
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(created_at)",
      fn: function(row) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("smallDate")(row.item.created_at)) + "\n\t\t\t")]
      }
    }, {
      key: "cell(price)",
      fn: function(row) {
        return [(row.item.price) ? _c('span', [_vm._v("€ " + _vm._s(Math.round(row.item.price)))]) : _vm._e()]
      }
    }, {
      key: "cell(buyer)",
      fn: function(row) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(row.item.buyer.full_name_simple) + "\n\t\t\t")]
      }
    }], null, false, 128597188)
  }) : _c('p', [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('pendingBid.noData')) + "\n\t\t")]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.pendingBids.total,
      "per-page": parseInt(_vm.pendingBids.per_page),
      "align": "right"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fa58248"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/PendingBid/PendingBidListSmall.vue
// module id = 1330
// module chunks = 1